
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect } from '@/components';
import { AppButton, AppFileUpload, AppImageHolder } from '@/components';
import useAppEdit from '@/modules/apps/model/edit';
import { ROUTE_NAME_APPLICATION } from '@/modules/apps/router';

export default defineComponent({
    name: ROUTE_NAME_APPLICATION.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppSelect, AppButton, AppFileUpload, AppImageHolder },
    setup() {
        const { model, v$, fetch, actions, currencyOptions } = useAppEdit();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, actions, currencyOptions };
    }
});
